import { Control, Controller, FieldValues } from "react-hook-form";
import { TextField } from "@mui/material";

type Props = {
  name: string;
  control: Control<FieldValues, any>;
  label: string;
  defaultValue?: string;
};

const InputField = ({ name, control, label, defaultValue }: Props) => {
  console.log("defaultValue", defaultValue, typeof defaultValue);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange } }) => (
        <TextField
          onChange={onChange}
          label={label}
          defaultValue={defaultValue}
        />
      )}
    />
  );
};

export default InputField;
